/**
 * ToastContainer component.
 */
import Colors from '@shared/assets/style/default/color';
import Screen from '@shared/utils/screen';
import styled from 'styled-components';
import { TRANSITION } from '@shared/types/constants/animations';

const ToastContainer = styled.div<{ visible: boolean }>`
  position: fixed;
  bottom: ${60 * Screen.widthRatio}px;
  left: 50%;
  transform: translateX(-50%);
  max-width: calc(100% - ${80 * Screen.widthRatio}px);
  background: ${Colors['dark']};
  border-radius: ${40 * Screen.widthRatio}px;
  padding: ${20 * Screen.widthRatio}px ${60 * Screen.widthRatio}px;
  opacity: ${(props) => (props.visible ? 1 : 0)};
  transition: ${TRANSITION.OPACITY_TRANSITION};
  z-index: 200; // Above content, same level as modals
`;

export default ToastContainer;
